var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',{attrs:{"disabled":true,"size":"small"},model:{value:(_vm.baseCount),callback:function ($$v) {_vm.baseCount=$$v},expression:"baseCount"}})}
var staticRenderFns = []

export { render, staticRenderFns }